import { TenantConcern } from '@models';
import { useStore } from '@stores';
import { useEffect } from 'react';

export const useTenantConcern = (
  id: string | undefined
): { tenantConcern: TenantConcern | undefined; loading: boolean } => {
  const { concernStore } = useStore();
  const { loading, tenantConcern } = concernStore;

  useEffect(() => {
    id && concernStore.getTenantConcern({ id });
    return () => concernStore.clearTenantConcern();
  }, [concernStore, id]);

  return {
    loading,
    tenantConcern,
  };
};
